export const initialName = (name) => name.charAt(0).toUpperCase();
